import React, {useState} from 'react';
import {css} from 'aphrodite';
import Markdown from '../../../Markdown';
import {DisclaimerModal} from '../../../Modals';

/**
 * Component to render highlight row cell with disclaimer text
 */
export const HighlightRowCell = ({settings, styleSheet, value, rowData}) => {
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  const handleDisclaimerClick = (e) => {
    e.preventDefault();
    setShowDisclaimerModal(true);
  };

  const handleHide = () => {
    setShowDisclaimerModal(false);
  };

  return (
    <>
      <div>
        <p>{value}</p>
        {settings?.table?.highlightRow?.disclaimerText && (
          <div className={css(styleSheet.highlightRowPara)}>
            <a className={css(styleSheet.highlightRowDisclaimer)} onClick={handleDisclaimerClick}>
              <Markdown>{settings.table.highlightRow.disclaimerText}</Markdown>
            </a>
          </div>
        )}
      </div>
      <DisclaimerModal
        settings={settings}
        styleSheet={styleSheet}
        showDisclaimerModal={showDisclaimerModal}
        handleHide={handleHide}
      />
    </>
  );
};

